import styled from '../../../../../../../styles/styledComponents/themeComponents';

export const BrandSimpleCardStyle = styled.div`
  img {
    width: 100%;
  }

  .title {
    max-width: 100%;
    font-size: 12px;
    margin-top: 8px;
    font-weight: bold;
    letter-spacing: -0.1px;
    color: black;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-align: center;
  }
`;
